<template>
  <v-snackbar
    multi-line
    v-model="snackbar.value"
    top
    right
    :timeout="snackbar.type == 'reload' ? 0 : 10000"
    :color="snackbar.type == 'error' ? 'red lighten-1' : snackbar.type == 'reload' ? 'blue' : snackbar.type"
  >

    <v-row no-gutters>
      <v-col
        cols="1"
      >
        <v-icon v-if="snackbar.type == 'error'" class="mr-3">mdi-alert-circle</v-icon>
        <v-icon v-else color="white" class="mr-3">mdi-information</v-icon>
      </v-col>
      <v-col
        cols="11"
      >
        <span v-html="snackbar.text"></span>

      </v-col>
    </v-row>
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-if="snackbar.type == 'reload'"
        class="white black--text"
        @click="
          () => {
            dismiss();
            if (snackbar.item.event && typeof snackbar.item.event === 'function') snackbar.item.event();
          }
        "
        >Muat Ulang</v-btn
      >
      <v-btn v-else text @click="snackbar.value = false">Tutup</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
// @group Global Component
export default {
  data: () => ({
    snackbar: {
      value: false,
      text: "",
      type: "success",
      cls: "black--text",
      item: null
    }
  }),
  methods: {
    // eslint-disable-next-line
    open(type, message, obj) {
      this.snackbar.text = message;
      this.snackbar.value = true;
      this.snackbar.type = type;
      this.snackbar.cls = `${type}--text`;
      this.snackbar.item = obj;
    },
    error(message, obj) {
      this.open("error", message, obj);
    },
    info(message, obj) {
      this.open("info", message, obj);
    },
    success(message, obj) {
      this.open("success", message, obj);
    },
    warning(message, obj) {
      this.open("warning", message, obj);
    },
    reload(message, obj) {
      this.open("reload", message, obj);
    },
    dismiss() {
      this.snackbar.value = false;
    }
  }
};
</script>

<style></style>
